import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MarketProfileOverviewComponent } from './marketprofile-overview/market-profile-overview.component';
import { UpdateMarketProfileFormComponent } from './update-market-profile-form/update-market-profile-form.component';
import { MarketProfileDetailsComponent } from './market-profile-details/market-profile-details.component';
import { CreateMarketProfileFormComponent } from './create-market-profile-form/create-market-profile-form.component';

const routes: Routes = [
  {
    path: 'market-profiles',
    component: MarketProfileOverviewComponent
  },
  {
    path: 'market-profiles/create',
    component: CreateMarketProfileFormComponent
  },
  {
    path: 'market-profiles/:id',
    component: MarketProfileDetailsComponent
  },
  {
    path: 'market-profiles/:id/edit',
    component: UpdateMarketProfileFormComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MarketProfileRoutingModule { }
